import React from 'react';
import SVGImage, { Props } from '../svg-image/svg-image';
import defaultStyles from './svg-pure-icon.scss';

export default (props: Omit<Props, 'styles'> & { style?: typeof defaultStyles }) => (
    <SVGImage style={{ image: defaultStyles.image }} {...props} />
);
